import React from 'react';
import { AtlasPromotionsV2ProductGrid } from 'src/components/AtlasV2Components/AtlasPromotionsV2PageComponents/AtlasPromotionsV2ProductGrid';
import AtlasPromotionsV2TopSection from 'src/components/AtlasV2Components/AtlasPromotionsV2PageComponents/AtlasPromotionsV2TopSection';
import AtlasV2PromotionsDoubleDropdownTopEntityChart from 'src/components/AtlasV2Components/AtlasPromotionsV2PageComponents/AtlasV2PromotionsDoubleDropdownTopEntityChart';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Atlas V2 Price Promotion V2 Page layout - Tab name: prices subtab name: promotion
 */
export const AtlasPricePromotionV2PageLayout = () => {
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <AtlasPromotionsV2TopSection />

        {!isProductEntity && <AtlasV2PromotionsDoubleDropdownTopEntityChart />}

        <AtlasV2PromotionsDoubleDropdownTopEntityChart
          groupByFieldOptions={[{ id: 'PromotionDealType', label: 'Deal Type' }]}
        />

        <AtlasPromotionsV2ProductGrid />
      </Flex>
    </BasePageContainer>
  );
};
